import { getFromLocalStorage, saveToLocalStorage } from "utils/localStorage";
import { VIMEO_STORAGE_KEY, VIDEO_PROGRESS_RESET_THRESHOLD } from "const";
import { encodeEmail } from "utils/common/common";

interface VideoProgress {
  time: number;
  isViewed?: boolean;
}

const saveProgress = (videoId: string, time: number, isViewed: boolean, email: string) => {
  const key = encodeEmail(VIMEO_STORAGE_KEY, email);
  const progress = getFromLocalStorage<Record<string, VideoProgress>>(key) ?? {};
  progress[videoId] = { time, isViewed };

  saveToLocalStorage(key, progress);
};

export const getProgress = (videoId: string, email: string) => {
  const key = encodeEmail(VIMEO_STORAGE_KEY, email);
  return getFromLocalStorage<Record<string, VideoProgress>>(key)?.[videoId];
};

export const updateTime = (videoId: string, currentTime: number, percent: number, isViewed: boolean, email: string) => {
  const time = percent >= VIDEO_PROGRESS_RESET_THRESHOLD ? 0 : currentTime;
  saveProgress(videoId, time, isViewed, email);
};

export const resetTime = (videoId: string | string[], email: string) => {
  if (typeof videoId === "string") {
    saveProgress(videoId, 0, false, email);
    return;
  }

  videoId.forEach(id => {
    saveProgress(id, 0, false, email);
  });
};
